import Button from "@mui/material/Button/Button";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";

interface IModalProps {
	title?: string;
	description?: string;
	isOpen: boolean;
	handleSave?: any;
	handleCancel: any;
	children?: JSX.Element;
	formToSubmitId?: string;
	wide?: boolean;
	ultraWide?: boolean;
	actionText?: string;
	cancelText?: string;
	hideSaveButton?: boolean;
	hideCancelButton?: boolean;
}

export default function FormModal(props: IModalProps) {
	return (
		<>
			<Dialog
				maxWidth={props.ultraWide ? "xl" : props.wide ? "lg" : "sm"}
				open={props.isOpen}
				onClose={props.handleCancel}
				scroll="paper"
				fullWidth
				aria-labelledby="form-dialog-title"
				style={{ minHeight: "100vh", maxHeight: "100vh" }}
			>
				<DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{props.description}</DialogContentText>
					{props.children}
				</DialogContent>
				<DialogActions>
					<>
						{!props.hideCancelButton && (
							<Button
								onClick={props.handleCancel}
								color="primary"
							>
								{props.cancelText ?? "Cancelar"}
							</Button>
						)}
						{!props.hideSaveButton && (
							<Button
								type="submit"
								form={props.formToSubmitId ?? "form"}
								color="primary"
							>
								{props.actionText ?? "Salvar"}
							</Button>
						)}
					</>
				</DialogActions>
			</Dialog>
		</>
	);
}
